import { Box, Button } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';

export default function PrintDownloadSupplier({
  componentRef,
  handleReactPrint,
  isRTL,
  no,
  isNew,
}: any) {
  if (isNew) return null;

  return (
    <Box
      display="flex"
      style={{
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginBottom: 10,
      }}
    >
      <Button
        variant="contained"
        color="primary"
        onClick={handleReactPrint}
        startIcon={<PrintIcon />}
        style={{ marginLeft: 10, marginRight: 10 }}
      >
        {isRTL ? 'طباعة' : 'Print'}
      </Button>
    </Box>
  );
}
